import Auth from 'shared/amplifyAuth'

export const getApiAuthorizationHeader = async () => {
  if (process.env.REACT_APP_E2E_AUTH_MODE === 'local') {
    const token = process.env.REACT_APP_E2E_LOCAL_TOKEN
    if (!token) {
      throw new Error(
        'REACT_APP_E2E_LOCAL_TOKEN is required when REACT_APP_E2E_AUTH_MODE=local'
      )
    }
    return {
      Authorization: `Bearer ${token}`,
    }
  }

  const token = (await Auth.currentSession()).getIdToken().getJwtToken()
  return { Authorization: `Bearer ${token}` }
}
